var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckAble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-circle-line-mono",
    clipPath: "url(#clip0_575_31636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M0.75 3.75C0.75 2.09315 2.09315 0.75 3.75 0.75H14.25C15.9069 0.75 17.25 2.09315 17.25 3.75V14.25C17.25 15.9069 15.9069 17.25 14.25 17.25H3.75C2.09315 17.25 0.75 15.9069 0.75 14.25V3.75Z",
    fill: "#414B56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9 7.65L8.7 11.85C8.55 12 8.4 12.075 8.175 12.075C7.95 12.075 7.8 12 7.65 11.85L5.1 9.3C4.8 9 4.8 8.55 5.1 8.25C5.4 7.95 5.85 7.95 6.15 8.25L8.175 10.275L11.85 6.6C12.15 6.3 12.6 6.3 12.9 6.6C13.2 6.9 13.2 7.35 12.9 7.65Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_31636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckAble);
export default __webpack_public_path__ + "static/media/icon_check_able.f7c9be6732405b687c7b05d1222323c6.svg";
export { ForwardRef as ReactComponent };